import React, { useEffect, useRef } from 'react';
import anime from 'animejs';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import useIntersection from './useIntersection';

const LinedTitle = styled.div`
  display: block;
  position: relative;
  width: 180px;
  height: 50px;
  padding-left: 20px;
  align-items: center;
  justify-content: center;

  .text {
    display: block;
    position: absolute;
    font-size: 3rem;
    margin: 0;
  }

  .line {
    width: 0;
    height: 80%;
    z-index: -1;
    position: relative;
    top: 50%;
    left: -15px;
    background-color: #35a16d;
    transform: skew(-10deg);
`;

function PageStyledTitle(props) {
  const { title, mClassName } = props;
  const ref = useRef(null);
  const inViewPort = useIntersection(ref, '-5px');
  // console.log(`Title not in view port${inViewPort}`);
  const animate = () => {
    const lineEl = document.querySelector(`.${mClassName}.line`);
    anime({
      targets: lineEl,
      width: ['0%', '60%'],
      easing: 'easeInOutExpo',
      duration: 600,
    });
  };

  useEffect(() => {
    if (inViewPort) {
      animate();
    }
  }, [inViewPort]);

  return (
    <LinedTitle ref={ref}>
      <h1 className="text">{title}</h1>
      <div className={`${mClassName} line`} />
    </LinedTitle>
  );
}

PageStyledTitle.defaultProps = {
  // inViewPort: false,
};

PageStyledTitle.propTypes = {
  title: PropTypes.string.isRequired,
  mClassName: PropTypes.string.isRequired,
  // inViewPort: PropTypes.bool,
};

export default PageStyledTitle;
